export class RegistrationAffiliated {

  federalCode: string;
  courseCode: string;
  name: string;
  invoiceCompany: string;

  constructor() {
    this.federalCode = null;
    this.courseCode = null;
    this.name = null;
    this.invoiceCompany = null;
  }

}



// WEBPACK FOOTER //
// ./src/models/registrationaffiliated.ts